import React, { useContext } from "react"
import { StyleSheet, View } from "react-native"
import { ThemeContext } from "../utility/context/ThemeContext"
import { MAX_CONTENT_WIDTH } from "../config"
import { SkeletonBlock, SkeletonGroup, SkeletonLine } from "../utility/skeleton"

export const InstitutionDetailsSkeleton = ({
  accountCardCount = 3,
}: {
  accountCardCount?: number
}): React.ReactElement => {
  const theme = useContext(ThemeContext).theme
  const { bgMain } = theme.colors

  const cards = Math.max(2, Math.min(6, accountCardCount))

  return (
    <View style={{ flex: 1, backgroundColor: bgMain }}>
      <View style={[styles.stats, { maxWidth: MAX_CONTENT_WIDTH }]}>
        <SkeletonGroup>
          <View style={{ width: "100%", gap: 10 }}>
            <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
              <SkeletonLine width={80} height={10} radius={8} />
              <SkeletonLine width={80} height={10} radius={8} />
            </View>
            <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <SkeletonLine width={140} height={22} radius={10} />
              <SkeletonLine width={40} height={22} radius={10} />
            </View>
          </View>
        </SkeletonGroup>
      </View>

      <View style={[styles.gridWrap, { maxWidth: MAX_CONTENT_WIDTH }]}>
        <SkeletonGroup>
          <View style={styles.grid}>
            {new Array(cards).fill(0).map((_, idx) => (
              <SkeletonBlock key={idx} style={styles.accountCard} radius={10} />
            ))}
          </View>
        </SkeletonGroup>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  stats: {
    padding: 16,
    width: "100%",
    alignSelf: "center",
  },
  gridWrap: {
    paddingHorizontal: 16,
    paddingBottom: 16,
    width: "100%",
    alignSelf: "center",
  },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    alignItems: "center",
    gap: 12,
  },
  accountCard: {
    width: 350,
    aspectRatio: 1.586,
    maxHeight: 240,
  },
})

